import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Role } from 'src/userRoles/userRoles';
import { Injectable } from '@angular/core';
import { BehaviorSubject,Observable,throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { JwtHelperService } from '@auth0/angular-jwt';

import { MessageService } from 'primeng/api';
import { CookieStorageService } from './cookie-storage.service';
import { UserRoleData } from '../UserRoleData';
import { environment } from 'src/environments/environment';

export class User {
  cvr: string;
  email: string;
  isKombitUser: boolean;
  isKombitAdmin: boolean;
  isKombitSupporter: boolean;
  isForvalterCvr: boolean;
  organisation: string;
  realname: string;
  roles: string[];
  isRouteSupporter: boolean;
  isRouteAdmin: boolean;
  username: string;

}

const jwtHelper = new JwtHelperService();
@Injectable()
export class AuthenticationService {

  private roleSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');
  private statusSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');

  constructor(private http: HttpClient, private storageService: CookieStorageService, private messageService: MessageService) {}

  /**
   *
   * @param {Response} response
   * @returns {any}
   */

  public onAuthenticationSuccess(token: string): void {
    const authenticatedUser: User = this.extractUserInfo(token);
    this.storageService.put('current_user', authenticatedUser);
    console.debug(
      `User authenticated as '${authenticatedUser.username}'. With cvr: ` +
        authenticatedUser.cvr
    );
  }

  /**
   * @returns {User}
   */

  public getCurrentUser(): User {
    return this.storageService.get('current_user');
  }

  public getCurrentUserName(): string {
    return this.getCurrentUser().realname;
  }

  public getCurrentUserId(): string {
    return this.getCurrentUser().username;
  }

  public getUserRoles(): string[] {
    return this.getCurrentUser().roles;
  }

   //CR183 FK-11 User’s consent for registraion.
   updateTermStatus(status: any): void
   {
     this.statusSubject.next(status);
   }

   getTermsStatusForModule()
   {
     return this.statusSubject.asObservable();
   }

  updateRoleForMenu(newRole: string): void {
    this.roleSubject.next(newRole);
  }

  public getUserRolesForMenubar(): Observable<string> {
    return this.roleSubject.asObservable();
  }

  updateAppRole(newRole: string): void {
    this.storageService.put('current_approle', newRole);
  }

  public getAppRole(): string {
    let approle: any;
    approle = this.storageService.get('current_approle');
    if (approle == null) {
      return "none";
    }
    return approle;
  }

  public canUserEdit(): boolean {
    let approle = this.getAppRole();
    return (approle == "admin" || approle == "authority_admin" || approle == "provider_admin");
  }

  public getRoleForUser(): Promise<string> {
    return new Promise((resolve, reject) => {
      this.getUserRole().then((approle) => {
        let roleName: string | undefined;
        let applicaltionRole: string | undefined;
        if (approle) {
          applicaltionRole = approle.role;
          if (applicaltionRole == "admin" || applicaltionRole == "supporter") {
            roleName = 'admin';
          } else if (applicaltionRole == "authority" || applicaltionRole == "authority_admin") {
            roleName = 'authority';
          } else if (applicaltionRole == "provider" || applicaltionRole == "provider_admin") {
            roleName = 'provider';
          }
        }

        if(applicaltionRole != "undefined" && !roleName)
        {
          roleName = 'none';
          applicaltionRole = 'none';
        }

        this.updateRoleForMenu(roleName!);
        // Ensure `approle` is defined before accessing `consentStatus`
        const consentStatus = approle?.consentStatus ?? null;
        if (consentStatus !== null) {
          this.updateTermStatus(consentStatus);
        }
        if (applicaltionRole !== undefined) {
          this.updateAppRole(applicaltionRole);
      }
        resolve(consentStatus!);
      }).catch((error)=>{
        reject(error);
      });
    });
  }

  /**
   *
   * @param {string} token
   * @returns {User}
   */
  private extractUserInfo(token: string): User {
    // Parse the JWT token into a TypeScript object

    const decoded = jwtHelper.decodeToken(token);

    // Throw away " // " divider and anything after (CVR number), in organisation name
    const organisationNameDivider = ' // ';

    const organisationName =
      decoded.organisation_name ? ( decoded.organisation_name.indexOf(organisationNameDivider) !== -1
        ? decoded.organisation_name.substring(0, decoded.organisation_name.indexOf(organisationNameDivider))
        : decoded.organisation_name
      ): 'N/A';

    const user: User = {
      realname: decoded.full_name,
      username: decoded.preferred_username,
      email: '',
      cvr: decoded.cvr_number,
      organisation: organisationName,
      roles: [],
      isKombitUser: false,
      isKombitAdmin: false,
      isKombitSupporter: false,
      isForvalterCvr: false,
      isRouteSupporter: false,
      isRouteAdmin: false,
    };

    // Apply the user's role(s) and set flag if he/she is a kombit admin or supporter.

    if (
      decoded.resource_access &&
      decoded.resource_access.spadmin_resource &&
      decoded.resource_access.spadmin_resource.roles
    ) {
      user.roles = decoded.resource_access.spadmin_resource.roles;

      const kombitAdmRoleSet =
        decoded.resource_access.spadmin_resource.roles.indexOf(
          'kombit_administrator'
        ) >= 0;
      const kombitSupRoleSet =
        decoded.resource_access.spadmin_resource.roles.indexOf(
          'kombit_supporter'
        ) >= 0;

      user.isKombitAdmin = kombitAdmRoleSet;
      user.isKombitSupporter = kombitSupRoleSet;
      user.isKombitUser = kombitAdmRoleSet || kombitSupRoleSet;
      //      user.isForvalterCvr = forvalterCvrs.indexOf(user.cvr) >= 0;
      user.isRouteSupporter =
        decoded.resource_access.spadmin_resource.roles.indexOf(
          'route_supporter'
        ) >= 0;
      user.isRouteAdmin =
        decoded.resource_access.spadmin_resource.roles.indexOf(
          'route_administrator'
        ) >= 0;
    }

    return user;
  }

  getUserRole(): Promise<UserRoleData> {
    let path = `${environment.adminApiUrl}role`;
    return this.http
      .get<any>(path)
      .pipe(catchError(this.handleError))
      .toPromise()
      .then((data) => {
        return data;
      })
      .catch((ex) => {
        console.error('Error fetching user role', ex);
      });
  }

  private handleError(error: HttpErrorResponse) {
    console.log(error.error);
    if (error.status === 0) {
      // A client-side or network error occurred. Handle it accordingly.
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(
        `Backend returned code ${error.status}, body was: `,
        error.error
      );
    }
    // Return an observable with a user-facing error message.
    return throwError('Something bad happened; please try again later.');
  }
}
